import PropTypes from 'prop-types';
import classes from "./Slide.module.scss";
import clsx from 'clsx';
import HTMLFormatter from "../HTMLFormatter";
import SlideMultimedia from "./SlideMultimedia";

export default function Slide({ slide, className, freeze }) {
    const { title, content, media } = slide;

    return (
        <div className={clsx(classes.slide, className)}>
            <h2 className={classes.title}>{title}</h2>
            <div className={classes.content}>
                {media && (
                    <div className={clsx(classes.column, classes.media, !content && classes.fullWidth)}>
                        <SlideMultimedia freeze={freeze} {...media} />
                    </div>
                )}
                {content && (
                    <div className={clsx(classes.column, !media && classes.fullWidth)}>
                        <HTMLFormatter html={content} />
                    </div>
                )}
            </div>
        </div>
    );
}

Slide.propTypes = {
    slide: PropTypes.shape({
        title: PropTypes.string,
        content: PropTypes.string,
        media: PropTypes.object
    }),
    className: PropTypes.string,
    freeze: PropTypes.bool
};